import React, { useEffect, useState } from 'react';
import './App.css';
import LandingPage from './components/LandingPage';
import './translations/i18n';
import { eventTypeEnum, languageEnum } from './types';

function App() {
  const [eventType, setEventType] = useState<eventTypeEnum | undefined>();
  const [language, setLanguage] = useState<languageEnum | undefined>();
  const [nbreRecurrence, setNbreRecurrence] = useState('');
	const path = window.location.search
  const urlParams = new URLSearchParams(path);
  const languageParam = urlParams.get('lang');
  const typeParam = urlParams.get('type');
  const recParam = urlParams.get('a');

  const retrieveLangEnum = (language: string): languageEnum | undefined => {
    const languageMap: { [key: string]: languageEnum } = {
		fr: languageEnum.French,
		en: languageEnum.English,
    };
    return languageMap[language] || undefined;
  }

  const retrieveTypeEnum = (type: string): eventTypeEnum | undefined => {
    const typeMap: { [key: string]: eventTypeEnum } = {
		questions: eventTypeEnum.Support,
		entretien: eventTypeEnum.Service,
		relation: eventTypeEnum.Relation,
		introduction: eventTypeEnum.Introduction,
		portal: eventTypeEnum.Portal,
    epsp: eventTypeEnum.Epsp
    };
    return typeMap[type] || undefined;
  }

  useEffect(() => {
    

    if (languageParam) {
      setLanguage(retrieveLangEnum(languageParam));
    }

    if (typeParam) {
      setEventType(retrieveTypeEnum(typeParam));
    }
    if(recParam){
      setNbreRecurrence(recParam);
    }
  }, [urlParams]);

  const handleEventType = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setEventType(event.target.value as eventTypeEnum);
  }

  const handleLanguage = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setLanguage(event.target.value as languageEnum);
  };
  /*const handleSubmitRecurrenceNbre = (recurrenceType: string) => {
		setNbreRecurrence(recurrenceType as string);
		console.log(recurrenceType);
    
	}*/
  const handleSubmitRecurrenceNbre = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setNbreRecurrence(event.target.value);
    // Pass the string value, not the event
  };
  return (
    <div className="App">
      <LandingPage
        handleEventType={handleEventType}
        handleLanguage={handleLanguage}
        handleSubmitRecurrenceNbre={handleSubmitRecurrenceNbre}
        nbreRecurrence={nbreRecurrence}
        eventType={eventType}
        language={language}
        recParam={recParam??''}
        path={path}
      />
    </div>
  );
}

export default App;
